import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\TeacherContentCommentController::index
* @see app/Http/Controllers/Teacher/TeacherContentCommentController.php:17
* @route '/teacher/content/{content}/comments'
*/
export const index = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/teacher/content/{content}/comments',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentCommentController::index
* @see app/Http/Controllers/Teacher/TeacherContentCommentController.php:17
* @route '/teacher/content/{content}/comments'
*/
index.url = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { content: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { content: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            content: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        content: typeof args.content === 'object'
        ? args.content.id
        : args.content,
    }

    return index.definition.url
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentCommentController::index
* @see app/Http/Controllers/Teacher/TeacherContentCommentController.php:17
* @route '/teacher/content/{content}/comments'
*/
index.get = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentCommentController::index
* @see app/Http/Controllers/Teacher/TeacherContentCommentController.php:17
* @route '/teacher/content/{content}/comments'
*/
index.head = (args: { content: string | number | { id: string | number } } | [content: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentCommentController::store
* @see app/Http/Controllers/Teacher/TeacherContentCommentController.php:46
* @route '/teacher/content/{content}/comments'
*/
export const store = (args: { content: string | number } | [content: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/teacher/content/{content}/comments',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentCommentController::store
* @see app/Http/Controllers/Teacher/TeacherContentCommentController.php:46
* @route '/teacher/content/{content}/comments'
*/
store.url = (args: { content: string | number } | [content: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { content: args }
    }

    if (Array.isArray(args)) {
        args = {
            content: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        content: args.content,
    }

    return store.definition.url
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentCommentController::store
* @see app/Http/Controllers/Teacher/TeacherContentCommentController.php:46
* @route '/teacher/content/{content}/comments'
*/
store.post = (args: { content: string | number } | [content: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\TeacherContentCommentController::deleteMethod
* @see app/Http/Controllers/Teacher/TeacherContentCommentController.php:62
* @route '/teacher/content/comments/{comment}'
*/
export const deleteMethod = (args: { comment: string | number | { id: string | number } } | [comment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/teacher/content/comments/{comment}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Teacher\TeacherContentCommentController::deleteMethod
* @see app/Http/Controllers/Teacher/TeacherContentCommentController.php:62
* @route '/teacher/content/comments/{comment}'
*/
deleteMethod.url = (args: { comment: string | number | { id: string | number } } | [comment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { comment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { comment: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            comment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        comment: typeof args.comment === 'object'
        ? args.comment.id
        : args.comment,
    }

    return deleteMethod.definition.url
            .replace('{comment}', parsedArgs.comment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\TeacherContentCommentController::deleteMethod
* @see app/Http/Controllers/Teacher/TeacherContentCommentController.php:62
* @route '/teacher/content/comments/{comment}'
*/
deleteMethod.delete = (args: { comment: string | number | { id: string | number } } | [comment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(args, options),
    method: 'delete',
})

const comments = {
    index: Object.assign(index, index),
    store: Object.assign(store, store),
    delete: Object.assign(deleteMethod, deleteMethod),
}

export default comments